import type { ReactNode } from 'react';

import styles from './ResourceMeta.module.css';

/** The secondary line of a catalog card (boards and databases share it): icon + text items. */
export function ResourceMeta({ children }: { children: ReactNode }) {
  return <span className={styles.meta}>{children}</span>;
}

/** An icon with visible text, e.g. the owner or the workspace of a card. */
export function MetaItem({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return (
    <span className={styles.item}>
      <span aria-hidden className={styles.glyph}>
        {icon}
      </span>
      {children}
    </span>
  );
}

/** An icon that carries its meaning alone (accessible name + tooltip), e.g. "Personal board". */
export function MetaIcon({ icon, label }: { icon: ReactNode; label: string }) {
  return (
    <span className={styles.item} role="img" aria-label={label} title={label}>
      {icon}
    </span>
  );
}

/** The leading icon of a card title: tells boards from databases at a glance. */
export function KindIcon({ icon, label }: { icon: ReactNode; label: string }) {
  return (
    <span className={styles.kind} role="img" aria-label={label} title={label}>
      {icon}
    </span>
  );
}
